import { useAction } from '@reatom/npm-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Result } from '@blade/std-lib'
import { useHapticFeedback } from '@blade/ui-kit'
import { startScanQrFlowEvent } from '@root/features/services/scan-qr/atoms'
import { ScanIcon, Separator as Separator_ } from '@root/shared/ui-kit'

type Props = {
  value: string
  onChange: (value: string) => void
}

export const WalletAddressInput: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation()
  const haptics = useHapticFeedback()
  const startScanQr = useAction(startScanQrFlowEvent)

  const handleScan = () => {
    haptics.impactOccurred('light')
    startScanQr({
      onScanned: (address) => {
        if (Result.isSuccess(address)) {
          haptics.impactOccurred('light')
          onChange(address.success)
        }
      },
    })
  }

  return (
    <Root>
      <Input
        placeholder={t('wallet.address_input_placeholder')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <Separator vertical />
      <ScanIcon onClick={handleScan} />
    </Root>
  )
}

const Root = styled.div`
  height: 48px;
  background: var(--appearance-1);
  border: 1px solid rgba(var(--background-12-rgb), 0.05);
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  padding-inline: 16px 12px;
`

const Input = styled.input`
  width: 100%;
  height: 100%;
  padding-inline: 0;
  outline: none;
  border: none;
  background: transparent;
  color: var(--text-12);
  font-size: 14px;

  &::placeholder {
    color: var(--text-9);
    font-style: italic;
  }
`

const Separator = styled(Separator_)`
  margin-inline: 8px 12px;
`
